<template>
  <section class="splash-page splash-page-mobile splash-page--mobile" v-show="!isLoading">
    <swiper
      @slideChange="onSlideChange"
      @touchMove="() => setOpacity()"
      @touchEnd="() => setOpacity(1)"
      :options="swiperOptions"
      :slides-per-view="2"
      :space-between="50"
      ref="mySwiper"
    >
      <swiper-slide>
        <div class="step1">
          <div v-show="verifyModuleVisibility('rotate')">
            <div :style="{ opacity }" :class="['component-img', regionIsApac ? 'component-img--apac' : '']">
              <slot></slot>
            </div>
            <div :class="['logo', regionIsApac ? 'logo--apac' : '']">
              <img :src="`${ customsAssets }/images/customizer/customs-logo.png`" />
            </div>
            <div :class="['rotate-up', regionIsApac ? 'rotate-up--apac' : '']">
              <img :src="`${ customsAssets }/images/customizer/rotate-up.png`" />
            </div>
            <transition name="hand-img-fade">
              <div v-if="!isTouchStarted" :class="['hand-img', regionIsApac ? 'hand-img--apac' : '']">
                <img :src="`${ customsAssets }/images/customizer/hand.png`" />
              </div>
            </transition>
            <div :class="['rotate-down', regionIsApac ? 'rotate-down--apac' : '']">
              <img :src="`${ customsAssets }/images/customizer/rotate-down.png`" />
            </div>
            <div :style="{ opacity }" :class="['label-rotate-down', regionIsApac ? 'label-rotate-down--apac' : '']">
              <label> {{ this.getRotateTranslation() }} </label>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="step2">
          <div
            :class="[ 'header-tools', regionIsApac ?  'apac' : '']"
            v-show="verifyModuleVisibility('header')"
          >
            <label>{{ getTranslation('headerTools') }}</label>
            <img :src="`${ customsAssets }/images/customizer/see-all-parts-arrow-step2.png`" />
          </div>
          <div
            :class="[ 'checkout-faqs', regionIsApac ?  'apac' : '']"
            v-show="verifyModuleVisibility('faqs')"
          >
            <button
             id="faqs"
             @click="faqsAction"
            >
            {{ getTranslation('faqs') }}</button>
          </div>
          <div class="add-your-own-all"
            v-show="verifyModuleVisibility('tabs')"
          >
            <label>{{ getTranslation('addYourOwn') }}</label>
            <img :src="`${ customsAssets }/images/customizer/swipe-to-access-arrow-step3.png`" />
          </div>
          <div class="see-all-customize-parts"
             v-show="verifyModuleVisibility('all_parts')"
           >
            <label>{{ getTranslation('allParts') }}</label>
            <img :src="`${ customsAssets }/images/customizer/see-all-parts-arrow-step2.png`" />
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
     </swiper>
    <modal-button-nav
      ref="modalButtonNav"
      :cta-primary-button="skipToGetStartedTranslation"
      :show-icon-button="false"
      :show-cta-secondary-button="false"
      :show-cta-primary-button="true"
      :block-cta-primary-button="false"
      @ctaPrimaryAction="onSkip"
      class="button-nav"
    ></modal-button-nav>
  </section>
</template>

<script>
import modalButtonNav from '@/components/Globals/ModalButtonNav';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

const SWIPER_OPTIONS = {
  pagination: {
    el: '.swiper-pagination',
    type: "bullets",
    clickable: false,
  }
};

const SPLASH_PAGE_OPEN_CLASS = 'splash-mobile-modal-open'

export default {
  name: "simplifiedSplashPage",
  components: {
    modalButtonNav,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    isTouchStarted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      swiperOptions: {
        ...SWIPER_OPTIONS
      },
      opacity: 1,
      styledElements: {},
      initialTimestamp: null
    }
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    customsAssets() {
      return this.$store.state.endPoints.customizer.customsAssets;
    },
    swiper() {
      return this.$refs.mySwiper && this.$refs.mySwiper.$swiper;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    regionIsApac() {
      return this.$store.getters['utils/regionIsApac'];
    },
    isSplashModalOpen() {
      return this.$store.state.utils.isSplashModalOpen;
    },
    isApparel() {
      return this.$store.getters['utils/isApparelEnabled'];
    },
    isBackpack() {
      return this.$store.state.utils.pdm !== null && this.$store.state.utils.pdm.sku === 'backpack';
    },
    skipToGetStartedTranslation() {
      return this.translations.simplifiedSplashPage.mobile['skipToGetStarted'];
    }
  },
  watch: {
    isLoading: {
      immediate: true,
      handler: 'onSlideChange',
    },
  },
  methods: {
    getTranslation(key) {
      return this.translations.simplifiedSplashPage.mobile[key];
    },
    setStyleForElements() {
      if(this.swiper.activeIndex === 0){
        document.getElementsByClassName('v--modal-overlay')[0].style.setProperty('z-index', '1100', 'important');
      }else{
        document.getElementsByClassName('v--modal-overlay')[0].style.zIndex = '';
      }
    },
    getSelectors() {
      const customizerHeaderKey = 'customizer-new-header';
      let selectors = {};

      selectors = {
        0: {
          [customizerHeaderKey]: SPLASH_PAGE_OPEN_CLASS,
          'swatches-view-header': SPLASH_PAGE_OPEN_CLASS
        },
        1: {
          [customizerHeaderKey]: SPLASH_PAGE_OPEN_CLASS,
          'swatches-view-header': SPLASH_PAGE_OPEN_CLASS
        },
        2: {
          [customizerHeaderKey]: SPLASH_PAGE_OPEN_CLASS
        }
      }
      if (this.verifyModuleVisibility('tabs')) {
        selectors[1]['splash-swatches-view-tabs'] = "splash-mobile-modal-open-second-step";
        selectors[1]['swatches-view-header'] = "splash-mobile-modal-open-second-step";
        selectors[1]['splash-swatches-view-tabs-mobile'] = "splash-mobile-modal-open-second-step";
      }
      if (this.verifyModuleVisibility('all_parts')) {
        if (!this.configuration.enableFlyOutMenu || !this.isApparel) {
          selectors[1]['customizer-navigation-main'] = SPLASH_PAGE_OPEN_CLASS;
        }
      } else {
        if (this.configuration.enableFlyOutMenu || this.isApparel) {
          selectors[0]['standard-arrow-navigation'] = SPLASH_PAGE_OPEN_CLASS;
          selectors[1]['standard-arrow-navigation'] = SPLASH_PAGE_OPEN_CLASS;
        }
      }
      if (this.verifyModuleVisibility('header')) {
        selectors[1]['customizer-new-header__container-other-buttons'] = "splash-mobile-modal-open-second-step";
      }

      return selectors;
    },
    /**
     * @function onSkip
     * Close the splash page
     */
    onSkip() {
      const timeElapsed = (Date.now() - this.initialTimestamp) / 1000;
      this.$customizerDataLayer.logAnalyticsEvent({
        type: this.$customizerDataLayer.types.customizerSplashPage,
        eventLabel: `Skip to Get Started - Slide ${ this.swiper.activeIndex + 1 } - ${ timeElapsed.toFixed(2) } sec`,
        forceEcomDataLayerFormat: true,
      });
      const selectors = this.getSelectors();

      for (const [key, value] of Object.entries(selectors[this.swiper.activeIndex])) {
        const elements = document.getElementsByClassName(key);

        if (elements && elements.length) {
          elements[0].classList.remove(value);
        }
      }
      document.getElementsByClassName('v--modal-overlay')[0].style.position = 'fixed';
      document.getElementsByClassName('swatches-view-header')[0].style.removeProperty('z-index');
      if (!this.configuration.enableFlyOutMenu && !this.isApparel) {
        document.getElementsByClassName('customizer-legacy-navigation')[0].style.removeProperty('opacity');
      }
      if(this.isSplashModalOpen){
        this.$emit("restoreModel3D");
      }
    },
    onSlideChange() {
      if (this.isLoading) {
        return;
      }

      if (!this.regionIsApac) {
        document.getElementsByClassName('v--modal-overlay')[0].style.position = 'initial';
      }
      if(this.swiper.activeIndex === 0){
        document.getElementsByClassName('v--modal-overlay')[0].style.setProperty('z-index', '1100', 'important');
      }else{
        document.getElementsByClassName('v--modal-overlay')[0].style.zIndex = '';
      }

      this.toggleSplashPageOpenClass();
      this.setStyleForElements();

      const addYourOwnParent = document.querySelector('.splash-swatches-view-tabs.splash-mobile-modal-open-second-step');

      if (addYourOwnParent) {
        addYourOwnParent.scrollLeft = 0;
      }
    },
    toggleSplashPageOpenClass() {
      const previousIndex = this.swiper.activeIndex === 1 ? this.swiper.activeIndex - 1 : this.swiper.activeIndex + 1;
      const selectors = this.getSelectors();
      for (let index of [previousIndex, this.swiper.activeIndex]) {
        let method = index === this.swiper.activeIndex ? 'add' : 'remove';
        for (const [key, value] of Object.entries(selectors[index])) {
          const elements = document.getElementsByClassName(key);

          if (elements && elements.length) {
            elements[0].classList[method](value);
          }
        }
      }
    },
    setOpacity(opacity = 0.7) {
      this.opacity = opacity;
    },
    verifyModuleVisibility(module) {
      // This is for a business requirement.
      // Since the settings are not by mobile and desktop level, this validations
      // should be made here
      if (module == 'all_parts' && (this.configuration.enableFlyOutMenu || this.isApparel)) {
        return false
      }
      const general_splash_page = this.$store.state.utils.configuration.splash_page.models_properties;
      const pdm_model = this.$store.state.utils.pdmModel;
      const model_splash_page = general_splash_page[pdm_model] || general_splash_page["default"];
      return model_splash_page[module];
    },
    faqsAction() {
      window.open(this.getTranslation('faqsLink'), '_blank');
      this.$customizerDataLayer.logAnalyticsEvent({
        type: this.$customizerDataLayer.types.customizerSplashPage,
        eventLabel: 'FAQ',
        forceEcomDataLayerFormat: true,
      });
    },
    getRotateTranslation() {
      if (this.isApparel) return this.getTranslation('rotateApparel');
      else if (this.isBackpack) return this.getTranslation('rotateBackpack');
      else return this.getTranslation('rotateShoe');
    },
  },
  created() {
    window.addEventListener('resize', this.setStyleForElements);
  },
  mounted() {
    this.initialTimestamp = Date.now();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setStyleForElements);
  }
}
</script>